import {GetBrigadesChips} from "./Balance";

class Station{
    constructor(id, name, brigades, trainCars) {
        this.id                = id;
        this.name              = name;
        this.brigades          = brigades;
        this.brigadesChips     = 0;
        this.locoBrigades      = 0;
        this.locoBrigadesChips = 0;
        this.trainCars         = trainCars;
        this.trainCarsPacks    = [];
        this.orderTrainPacks   = [];
        this.contractors       = 0;
        this.additionalChips   = 0;
        this.locoContractors   = 0;
        this.overtimeChips     = 0;
        this.clientPlaces      = null;
    }

    copy(station){
        this.id                = station.id;
        this.name              = station.name;
        this.brigades          = station.brigades;
        this.brigadesChips     = station.brigadesChips;
        this.locoBrigades      = station.locoBrigades;
        this.locoBrigadesChips = station.locoBrigadesChips;
        this.trainCars         = station.trainCars;
        this.trainCarsPacks    = station.trainCarsPacks;
        this.orderTrainPacks   = station.orderTrainPacks ?? [];
        this.contractors       = station.contractors ?? 0;
        this.additionalChips   = station.additionalChips ?? 0;
        this.locoContractors   = station.locoContractors ?? 0;
        this.overtimeChips     = station.overtimeChips ?? 0;
        this.clientPlaces      = station.clientPlaces;
    }
    renew(){
        this.brigadesChips     = GetBrigadesChips("station") * this.brigades;
        this.locoBrigadesChips = GetBrigadesChips("loco") * this.locoBrigades;
    }
    hireContractors(count){
        this.contractors   += count;
        this.brigadesChips += this.contractors * 4;
    }
    hireContractorsLoco(count){
        this.locoContractors += count;
    }
    getBrigadeChips(){
        return  this.brigadesChips + this.additionalChips;
    }
    payOvertime(count){
        this.overtimeChips += count;
        this.brigadesChips += count;
    }
}

export default Station;